import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit, half } = measures

export const signupContainer = css`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const signupSection = css`
  width: 90%;
  max-width: 800px;
  padding-top: ${2 * unit}px;
  ${MQ.PHONES} {
    padding-top: 0;
  }
  ${MQ.TABLETS_HORIZONTAL} {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`

export const tabList = css`
  border: none;
  text-align: center;
  list-style: none;
  margin-bottom: ${unit}px;
`

export const tab = css`
  display: inline-block;

  position: relative;

  margin: 0 ${half}px;

  padding: ${unit}px;
  min-width: ${10 * unit}px;

  border-bottom: 2px solid ${colors.grays.gray1};

  outline: none;

  cursor: pointer;
`

export const selectedTab = css`
  color: ${colors.oranges.orange1};
  border-color: ${colors.oranges.orange4};
`

export const formInfo = css`
  text-align: center;
`

export const signUpImgBanner = css`
  width: auto;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  ${MQ.TABLETS_HORIZONTAL} {
    display: none;
  }
`

export const mobileView = css`
  display: none;
  background-color: ${colors.grays.gray6};
  margin: 0;
  padding: 0;
  
  ${MQ.TABLETS} {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    overflow: hidden;
  }
`

export const desktopView = css`
  display: block;
  
  ${MQ.TABLETS} {
    display: none;
  }
`
